if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.textarea = this.querySelector('textarea');

        // this.updateCartNote();

        this.addEventListener('input', () => {
          clearTimeout(this.debounceTimer);

          this.debounceTimer = setTimeout(() => this.updateCartNote(), 500);
        });
      }

      updateCartNote() {
        const body = JSON.stringify({ note: this.textarea?.value });

        fetch(`${window.routes.cartUpdateUrl}`, { ...this.fetchConfig(), ...{ body } });
      }

      fetchConfig(type = 'json') {
        return {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
        };
      }
    },
  );
}
